import { render } from "./CadastroAvisoSistemaView.vue?vue&type=template&id=fcf32c44"
import script from "./CadastroAvisoSistemaView.vue?vue&type=script&lang=js"
export * from "./CadastroAvisoSistemaView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__